import React from 'react';
import styles from "../BaseSimplePage/BaseSimpleItemEditorHeader.module.css";
import {Divider, Typography} from "@mui/material";

const ArtistSuggestionsItemEditorHeader = ({editItemId, step}) => {
    return (
        <div className={styles.main}>
            <Typography variant="h6" sx={{fontWeight: "bold", marginBottom: "0px"}}>
                {`Обработка заявки (id=${editItemId})`}
            </Typography>
            <Typography variant="h6" sx={{fontWeight: "bold", marginBottom: "10px"}}>
                {`Шаг ${step} - ${getStepTitle(step)}`}
            </Typography>
            <Divider component="div"/>
        </div>
    );
};

function getStepTitle(step) {
    switch (step) {
        case 1: return "Проверка корректности заявки";
        case 2: return "Поиск заявленного имени в базе Культураты";
        case 3: return "Добавление автора из заявки";
        default: return "";
    }
}

export default ArtistSuggestionsItemEditorHeader;